var loadMore = function loadMore() {
	var $ = require('jquery');
	require('jquery-match-height');

	var $trigger = $('.js-load-more--news a');
	var $container = $('.posts-wrapper');

	if($trigger.length) {
		$trigger.click(function(e) {
			e.preventDefault();

			$.get($(this).attr('href') + '/', function(data) {
				var $link = $(data).filter('.ajax-pagination-link');
				if($link.length) {
					$trigger.attr('href', $link.text());
				} else {
					$trigger.remove();
				}

				$container.append($(data).not('.ajax-pagination-link'));

				$('.item__heading').matchHeight();

			});
		});
	}
}

module.exports = loadMore;
